import React, { Fragment, useState } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { history } from '../../redux'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
import yn from 'yn'
import MediaQuery from 'react-responsive'
import NavTabHeader from './NavTabHeader'
import NavTabHeaderMobile from './NavTabHeaderMobile'
import AccessibilityMessage from './AccessibilityMessage'
import { getButton } from 'Shared/GTM/getButton'

const defaulsState = {
  isMessageClosed: window.localStorage.getItem('isMessageClosed') || false
}

const IuppHeaderDisconnected = ({ profile }) => {
  const [ownState, setOwnState] = useState(defaulsState)

  const closeMessage = () => {
    setOwnState({
      ownState,
      isMessageClosed: true
    })
    window.localStorage.setItem('isMessageClosed', true)
    document.querySelector('.logo-header').focus()
  }

  const redirectLoginPage = () => {
    window.location.href = '/auth/login'
  }

  const returnHome = () => {
    history.push('/')
  }

  const focusOutOnClick = (section) => {
    document.activeElement.blur()

    setTimeout(() => {
      document.querySelector(`${section} h2`).setAttribute('tabindex', '0')
      document.querySelector(`${section} h2`).focus()
      document.querySelector(`${section} h2`).addEventListener('blur', function () {
        document.querySelector(`${section} h2`).removeAttribute('tabindex')
      })
    }, 800)
  }

  return (
    <Fragment>
      <div className='placeholder-header' />
      <header className={`iupp-header header-disconnected ${!yn(ownState.isMessageClosed) && 'header-disconnected-mobile-message'}`}>
        {yn(process.env.REACT_APP_ACCESSIBILITY_MESSAGE) && (
          <Fragment>
            <MediaQuery minWidth={490}>
              {!ownState.isMessageClosed && (
                <AccessibilityMessage
                  isMessageClosed={ownState.isMessageClosed}
                  closeMessage={() => closeMessage()}
                />
              )}
            </MediaQuery>
          </Fragment>
        )}
        <MediaQuery minWidth={800} maxWidth={960}>
          <NavTabHeader profile={profile} focusOutOnClick={() => focusOutOnClick()} {...ownState} />
        </MediaQuery>
        <MediaQuery minWidth={1025}>
          <NavTabHeader profile={profile} focusOutOnClick={() => focusOutOnClick()} {...ownState} />
        </MediaQuery>
        <nav aria-label='principal' className={`menu menu-navigation ${!yn(ownState.isMessageClosed) && 'h-auto pt-0 pb-1 py-lg-2'}`}>
          {yn(process.env.REACT_APP_ACCESSIBILITY_MESSAGE) && (
            <Fragment>
              <MediaQuery maxWidth={489}>
                {!ownState.isMessageClosed && (
                  <AccessibilityMessage
                    isMessageClosed={ownState.isMessageClosed}
                    closeMessage={() => closeMessage()}
                  />
                )}
              </MediaQuery>
            </Fragment>
          )}
          <div className='container'>
            {history.location.pathname === '/' ? (
              <a
                href='#'
                className={`d-block d-lg-flex mx-auto mx-lg-0 logo-header logo-header-img logo-header-link ${!yn(ownState.isMessageClosed) && 'pos-relative top-half mt-1'}`}
                aria-label='Logo iupp itaú'
              />
            ) : (
              <a
                href='#'
                onClick={returnHome}
                className={`d-block d-lg-flex mx-auto mx-lg-0 logo-header logo-header-img logo-header-link ${!yn(ownState.isMessageClosed) && 'pos-relative top-half mt-1'}`}
                aria-label='Logo iupp itaú'
              />
            )}
            <MediaQuery minWidth={490} maxWidth={960}>
              <div className='flexible-items-container' role='menu'>
                {history.location.pathname === '/' ? (
                  <React.Fragment>
                    <AnchorLink
                      role='menuitem'
                      href='#experiences'
                      data-target='#experiences'
                      className='flex-item mn-item mn-experiences'
                      onClick={() => {
                        getButton(false, 'home', 'clique:menu', 'experiencias')
                        focusOutOnClick('#experiences')
                      }}
                    >
                      experiências
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#accumulatePoints'
                      data-target='#accumulatePoints'
                      className='flex-item mn-item mn-accumulate-points'
                      onClick={() => {
                        getButton(false, 'home', 'clique:menu', 'junte-pontos')
                        focusOutOnClick('#accumulatePoints')
                      }}
                    >
                      junte pontos
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#usePoint'
                      data-target='#usePoint'
                      className='flex-item mn-item mn-use-points'
                      onClick={() => {
                        getButton(false, 'home', 'clique:menu', 'use-pontos')
                        focusOutOnClick('#usePoint')
                      }}
                    >
                      use pontos
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#benefits'
                      data-target='#benefits'
                      className='flex-item mn-item mn-benefits'
                      onClick={() => {
                        getButton(false, 'home', 'clique:menu', 'descontos')
                        focusOutOnClick('#benefits')
                      }}
                    >
                      descontos
                    </AnchorLink>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <a href='#experiences' className='flex-item mn-item mn-experiences' onClick={() => {
                      returnHome()
                      focusOutOnClick('#experiences')
                      getButton(false, 'home', 'clique:menu', 'experiencias')
                    }}>experiências</a>
                    <a href='#accumulatePoints' className='flex-item mn-item mn-accumulate-points' onClick={() => {
                      returnHome()
                      focusOutOnClick('#accumulatePoints')
                      getButton(false, 'home', 'clique:menu', 'junte-pontos')
                    }}>junte pontos</a>
                    <a href='#usePoint' className='flex-item mn-item mn-use-points' onClick={() => {
                      returnHome()
                      focusOutOnClick('#usePoint')
                      getButton(false, 'home', 'clique:menu', 'use-pontos')
                    }}>use pontos</a>
                    <a href='#benefits' className='flex-item mn-item mn-benefits' onClick={() => {
                      returnHome()
                      focusOutOnClick('#benefits')
                      getButton(false, 'home', 'clique:menu', 'descontos')
                    }}>descontos</a>
                  </React.Fragment>
                )}

                <Button
                  onClick={() => {
                    redirectLoginPage()
                    getButton(false, 'home', 'clique:botao', 'entrar')
                  }}
                  text='entrar'
                  className='flex-item mn-item mn-login'
                />
                <Button
                  onClick={() => {
                    redirectLoginPage()
                    getButton(false, 'home', 'clique:botao', 'cadastre-se')
                  }}
                  text='cadastre-se'
                  className='flex-item mn-item mn-register'
                />
              </div>
            </MediaQuery>
            <MediaQuery minWidth={961} maxWidth={1025}>
              <div className='flexible-items-container' role='menu'>
                {history.location.pathname === '/' ? (
                  <React.Fragment>
                    <AnchorLink
                      role='menuitem'
                      href='#experiences'
                      data-target='#experiences'
                      className='flex-item mn-item mn-experiences'
                      onClick={() => {
                        getButton(false, 'home', 'clique:menu', 'experiencias')
                        focusOutOnClick('#experiences')
                      }}
                    >
                      experiências
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#accumulatePoints'
                      data-target='#accumulatePoints'
                      className='flex-item mn-item mn-accumulate-points'
                      onClick={() => {
                        getButton(false, 'home', 'clique:menu', 'junte-pontos')
                        focusOutOnClick('#accumulatePoints')
                      }}
                    >
                      junte pontos
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#usePoint'
                      data-target='#usePoint'
                      className='flex-item mn-item mn-use-points'
                      onClick={() => {
                        getButton(false, 'home', 'clique:menu', 'use-pontos')
                        focusOutOnClick('#usePoint')
                      }}
                    >
                      use pontos
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#benefits'
                      data-target='#benefits'
                      className='flex-item mn-item mn-benefits'
                      onClick={() => {
                        getButton(false, 'home', 'clique:menu', 'descontos')
                        focusOutOnClick('#benefits')
                      }}
                    >
                      descontos
                    </AnchorLink>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <a href='#experiences' className='flex-item mn-item mn-experiences' onClick={() => {
                      returnHome()
                      focusOutOnClick('#experiences')
                      getButton(false, 'home', 'clique:menu', 'experiencias')
                    }}>experiências</a>
                    <a href='#accumulatePoints' className='flex-item mn-item mn-accumulate-points' onClick={() => {
                      returnHome()
                      focusOutOnClick('#accumulatePoints')
                      getButton(false, 'home', 'clique:menu', 'junte-pontos')
                    }}>junte pontos</a>
                    <a href='#usePoint' className='flex-item mn-item mn-use-points' onClick={() => {
                      returnHome()
                      focusOutOnClick('#usePoint')
                      getButton(false, 'home', 'clique:menu', 'use-pontos')
                    }}>use pontos</a>
                    <a href='#benefits' className='flex-item mn-item mn-benefits' onClick={() => {
                      returnHome()
                      focusOutOnClick('#benefits')
                      getButton(false, 'home', 'clique:menu', 'descontos')
                    }}>descontos</a>
                  </React.Fragment>
                )}

                <Button
                  onClick={() => {
                    getButton(false, 'home', 'clique:menu', 'entrar')
                    redirectLoginPage()
                  }}
                  text='entrar'
                  className='flex-item mn-item mn-login'
                />
                <Button
                  onClick={() => {
                    getButton(false, 'home', 'clique:menu', 'cadastre-se')
                    redirectLoginPage()
                  }}
                  text='cadastre-se'
                  className='flex-item mn-item mn-register'
                />
              </div>
            </MediaQuery>
            <MediaQuery minWidth={1026}>
              <div className='flexible-items-container' role='menu'>
                {history.location.pathname === '/' ? (
                  <React.Fragment>
                    <AnchorLink
                      role='menuitem'
                      href='#experiences'
                      data-target='#experiences'
                      className='flex-item mn-item mn-experiences'
                      onClick={() => {
                        focusOutOnClick('#experiences')
                        getButton(false, 'home', 'clique:menu', 'experiencias')
                      }}
                    >
                      experiências
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#accumulatePoints'
                      data-target='#accumulatePoints'
                      className='flex-item mn-item mn-accumulate-points'
                      onClick={() => {
                        focusOutOnClick('#accumulatePoints')
                        getButton(false, 'home', 'clique:menu', 'junte-pontos')
                      }}
                    >
                      junte pontos
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#usePoint'
                      data-target='#usePoint'
                      className='flex-item mn-item mn-use-points'
                      onClick={() => {
                        focusOutOnClick('#usePoint')
                        getButton(false, 'home', 'clique:menu', 'use-pontos')
                      }}
                    >
                      use pontos
                    </AnchorLink>
                    <AnchorLink
                      role='menuitem'
                      href='#benefits'
                      data-target='#benefits'
                      className='flex-item mn-item mn-benefits'
                      onClick={() => {
                        focusOutOnClick('#benefits')
                        getButton(false, 'home', 'clique:menu', 'descontos')
                      }}
                    >
                      descontos
                    </AnchorLink>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <a href='#experiences' className='flex-item mn-item mn-experiences' onClick={() => {
                      returnHome()
                      focusOutOnClick('#experiences')
                      getButton(false, 'home', 'clique:menu', 'experiencias')
                    }}>experiências</a>
                    <a href='#accumulatePoints' className='flex-item mn-item mn-accumulate-points' onClick={() => {
                      returnHome()
                      focusOutOnClick('#accumulatePoints')
                      getButton(false, 'home', 'clique:menu', 'junte-pontos')
                    }}>junte pontos</a>
                    <a href='#usePoint' className='flex-item mn-item mn-use-points' onClick={() => {
                      returnHome()
                      focusOutOnClick('#usePoint')
                      getButton(false, 'home', 'clique:menu', 'use-pontos')
                    }}>use pontos</a>
                    <a href='#benefits' className='flex-item mn-item mn-benefits' onClick={() => {
                      returnHome()
                      focusOutOnClick('#benefits')
                      getButton(false, 'home', 'clique:menu', 'descontos')
                    }}>descontos</a>
                  </React.Fragment>
                )}

                <Button
                  onClick={() => {
                    redirectLoginPage()
                    getButton(false, 'home', 'clique:botao', 'entrar')
                  }}
                  text='entrar'
                  className='flex-item mn-item mn-login'
                />
                <Button
                  onClick={() => {
                    redirectLoginPage()
                    getButton(false, 'home', 'clique:botao', 'cadastre-se')
                  }}
                  text='cadastre-se'
                  className='flex-item mn-item mn-register'
                />
              </div>
            </MediaQuery>
          </div>
        </nav>
        <MediaQuery maxWidth={1024}>
          <NavTabHeaderMobile focusOutOnClick={() => focusOutOnClick()} {...ownState} />
        </MediaQuery>
      </header>
    </Fragment>
  )
}

IuppHeaderDisconnected.propTypes = {
  profile: PropTypes.object
}

export default IuppHeaderDisconnected



// WEBPACK FOOTER //
// ./src/App/Header/IuppHeaderDisconnected.js